module.exports = __webpack_public_path__ + "static/media/result.c8611188.svg";